/** Development reset control retained because it is part of the v67 prototype. */
export function ResetDemoControl() {
  return <button className="resetchip" id="resetChip" title="Clear everything and start again as a new user">↺ Reset demo</button>;
}
